
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import  notaventa from './resumen-menu-archivos-nota.vue';
    import mercadopago from './resumen-menu-archivos-nota-mercadopago.vue';
    import presupuesto from './resumen-menu-archivos-presupuesto.vue';
    import etiquetaenvio from './resumen-menu-archivos-etiqueta-envio.vue';
    import declaracion from './resumen-menu-archivos-declaracion.vue';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            notaventa,
            presupuesto,
            mercadopago,
            etiquetaenvio,
            declaracion,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        Abrir()
        {
            this.Controlador.Vista.BarraDerecha.Modo = 'archivos';
        }
    }
